





























import { defineComponent } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import ShowMoreOptions from '@/components/common/show-more-options/index.vue';

const name = 'ttam-app-events-app-ios-hint';

const IOS_TIPS_LIST = () => [
  { index: 0, text: i18n.t('creative_tracking_app_events_width_ios14_policy') },
  { index: 1, text: i18n.t('creative_tracking_app_events_width_ios') },
];

export default defineComponent({
  name,
  components: {
    ShowMoreOptions,
  },
  props: {},
  setup() {
    const tipsList = IOS_TIPS_LIST();

    return {
      name,
      tipsList,
    };
  },
});
